import { render, staticRenderFns } from "./ProviderTypeDetail.vue?vue&type=template&id=c702e800"
import script from "./ProviderTypeDetail.vue?vue&type=script&lang=js"
export * from "./ProviderTypeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports